export var EventType;
(function (EventType) {
    EventType["AddToCart"] = "addtocart";
    EventType["Transaction"] = "transaction";
    EventType["View"] = "view";
})(EventType || (EventType = {}));
//# sourceMappingURL=event-type.js.map